/* Core & libraries */
import React, { useEffect, useState } from "react";

/* Helpers, constants, custom methods, internal libraries */
import { useAirlineProgramsService } from "../../services/airlineProgramsService.js";
import { PAGE_TITLES } from "../../constants/appConstants";
import { useAnalytics } from "../../hooks/useAnalytics";

/* Components */
import DLProgramHeader from "../../components/dlProgramHeader/index.js";
import DLProgramContent from "../../components/dlProgramContent/index.js";

/* Styles */

const ProgramDL = () => {
    const { getAirlineProgramsData, delinkDeltaAirlines, airlineProgramsData, joinDeltaAirlines } = useAirlineProgramsService();
    const { initAnalytics } = useAnalytics();
    const [deltaAirlinesSupplier, setDeltaAirlinesSupplier] = useState({});

    useEffect(() => {
        (async () => {
            await getAirlineProgramsData()
        })();
        const initUtagData = {
            channel: 'content',
            pageName: PAGE_TITLES["deltaAirlines"]
        };
        initAnalytics(initUtagData, 'init call', 'view')
    }, []);

    useEffect(() => {
        setDeltaAirlinesSupplier(airlineProgramsData?.suppliers?.filter(
            supplier => supplier.providerName === "Delta Airlines"
        )[0])
    }, [airlineProgramsData]);

    return (
        <div className="program-page">
            <DLProgramHeader airlineProgramsData={airlineProgramsData}/>
            <DLProgramContent 
                delinkDeltaAirlines={delinkDeltaAirlines} 
                deltaAirlinesSupplier={deltaAirlinesSupplier} 
                joinDeltaAirlines={joinDeltaAirlines}
            />
        </div>
    )
}

export default ProgramDL;
